module.exports = __webpack_public_path__ + "img/logo.61caed45.svg";